import React, { useEffect, useState } from 'react';
import { NEON_MULTI_NAV_COLORS } from '../../preferences/dashboard-preferences';
import { DashboardNavIcon } from './dashboard-nav.config';
import styles from './dashboard-nav.module.scss';

export function useQuickcamIconSet(): string {
  const [iconSet, setIconSet] = useState(
    () => document.documentElement.dataset.quickcamIcons || 'standard',
  );

  useEffect(() => {
    const root = document.documentElement;
    const sync = () =>
      setIconSet(root.dataset.quickcamIcons || 'standard');
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(root, {
      attributes: true,
      attributeFilter: ['data-quickcam-icons'],
    });
    return () => observer.disconnect();
  }, []);

  return iconSet;
}

export function neonMultiStyle(
  navId: string,
  iconSet: string,
): React.CSSProperties | undefined {
  if (iconSet !== 'neon-multi') return undefined;
  const color = NEON_MULTI_NAV_COLORS[navId];
  if (!color) return undefined;
  return { ['--neon-icon-color' as string]: color };
}

type NavNeonIconProps = {
  icon: DashboardNavIcon;
};

/** Dual-layer neon icon used by DashboardNavList and Settings overlay. */
export function NavNeonIcon({ icon }: NavNeonIconProps): JSX.Element {
  if (icon.kind === 'image') {
    return (
      <span className={styles.neonIconWrap} style={{ width: 30 }}>
        <span className={styles.neonIconGlow} aria-hidden="true">
          <img className={styles.iconImage} src={icon.src} alt="" />
        </span>
        <img
          className={`${styles.iconImage} ${styles.neonIconSharp}`}
          src={icon.src}
          alt={icon.alt}
        />
      </span>
    );
  }
  return (
    <span className={styles.neonIconWrap}>
      <span
        className={`material-icons ${styles.neonIconGlow}`}
        aria-hidden="true"
      >
        {icon.name}
      </span>
      <span
        className={`material-icons ${styles.iconMaterialDesign} ${styles.neonIconSharp}`}
      >
        {icon.name}
      </span>
    </span>
  );
}
